import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TTelemetryResponseRTc,
  TImgResponseRTc,
  TSegmentsLastHourResponseRTc,
  TStreetsResponseRTc,
  TEventsResponseRTc,
  TKtsHoursResponseRTc,
} from 'response/RTcResponce';

type TRTc = {
  isFetching: boolean;
  error: string;
  rtc_telemetry: TTelemetryResponseRTc;
  rtc_image: TImgResponseRTc;
  rtc_kts_last_hour: TSegmentsLastHourResponseRTc;
  rtc_streets: TStreetsResponseRTc;
  rtc_events_last: TEventsResponseRTc;
  rtc_events_alls: TEventsResponseRTc;
  rtc_kts_hours: TKtsHoursResponseRTc;
};

const initialState: TRTc = {
  isFetching: false,
  error: '',
  rtc_telemetry: {
    oID: '',
    online: false,
    error: false,
    configuration: false,
    need_restart: false,
    online_time: 0,
    vprocessor_oID: '',
  },
  rtc_image: {
    oID: '',
    img: '',
  },
  rtc_streets: {
    oID: '',
    streets: {},
    directions: {},
  },
  rtc_kts_last_hour: {
    oID: '',
    data: [
      {
        oID: '',
        KTS: 0,
        KTK: 0,
        KTD: 0,
        KTP: 0,
        speed: 0,
      },
    ],
  },
  rtc_events_last: {
    oID: '',
    events: [
      {
        utime: 0,
        status: '',
        msg: '',
      },
    ],
  },
  rtc_events_alls: {
    oID: '',
    events: [
      {
        utime: 0,
        status: '',
        msg: '',
      },
    ],
  },
  rtc_kts_hours: {
    oID: '',
    data: [
      {
        utime: 0,
        kts_value: 0,
      },
    ],
  },
};

export const rtcSlice = createSlice({
  name: 'rtc',
  initialState,
  reducers: {
    // rtc start
    rtcFetching(state) {
      state.isFetching = true;
    },
    // rtc succes
    rtcSuccesTelemety(state, action: PayloadAction<TTelemetryResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_telemetry = action.payload;
    },
    rtcSuccesImg(state, action: PayloadAction<TImgResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_image = action.payload;
    },
    rtcSuccesStreets(state, action: PayloadAction<TStreetsResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_streets = action.payload;
    },
    rtcSuccesKtsLastHour(state, action: PayloadAction<TSegmentsLastHourResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_kts_last_hour = action.payload;
    },
    rtcSuccesEventsLast(state, action: PayloadAction<TEventsResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_events_last = action.payload;
    },
    rtcSuccesEventsAlls(state, action: PayloadAction<TEventsResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_events_alls = action.payload;
    },
    rtcSuccesKtsHours(state, action: PayloadAction<TKtsHoursResponseRTc>) {
      state.isFetching = false;
      state.error = '';
      state.rtc_kts_hours = action.payload;
    },
    // rtc error
    rtcError(state, action: PayloadAction<string>) {
      state.isFetching = false;
      state.error = action.payload;
    },
    // rtc reset
    rtcReset() {
      return initialState;
    },
  },
});

export default rtcSlice.reducer;
